import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { PositionsService } from "../../services/position.service";
import { findPositionAct, loadPositionByIdAct, savePositionAct, saveSuccessPositionAct, setViolationsPositionAct, showMsgErrorAct, updatePositionAct, updateSuccessPositionAct } from "./position.actions";
import { catchError, exhaustMap, map, of, tap } from "rxjs";
import { AlertaService } from "../../services/alerta.service";

@Injectable()
export class PositionsEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private positionsService = inject(PositionsService);
    private alerta = inject(AlertaService);
    
    /*CRUD CATALOG POSITIONS*/

    findPositionEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findPositionAct),
            exhaustMap(action => this.positionsService.getPositionById(action.id)
        .pipe(
            map(position => loadPositionByIdAct({ position })),
            catchError(error => of(error))
        ))
        )
    );

    savePositionEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(savePositionAct),
            exhaustMap(action => this.positionsService.savePosition(action.positionNew)
                .pipe(
                    map(positionNew => saveSuccessPositionAct({ positionNew })),
                    catchError(error => (error.status == 400) ? of(setViolationsPositionAct({ positionForm: action.positionNew, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))                        
                    )
                )
            )
        )
    );

    saveSuccessPositionEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessPositionAct),
        tap(() => {
            this.router.navigate(['/positions']);
                this.alerta.correct("Posición editada con exito");
            })
        ), { dispatch: false }
    );

    updatePositionEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updatePositionAct),
            exhaustMap(action => this.positionsService.updatePosition(action.positionUpdated)
                .pipe(
                    map(positionUpdated => updateSuccessPositionAct({ positionUpdated })),
                    catchError(error => (error.status == 400) ? of(setViolationsPositionAct({ positionForm: action.positionUpdated, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))
                    )
                )
            )
        )
    );
    
    updateSuccessPositionEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessPositionAct),
        tap(() => {
            this.router.navigate(['/positions']);
            this.alerta.correct("Posición editada con exito");
        })
    ), {dispatch: false});
    /*CRUD CATALOG POSITIONS END*/
    showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgErrorAct),
            tap((action) => {
                this.alerta.error("Se ha precentado un error interno: ", {detail: action.error.message});
            })
        ), { dispatch: false }
    );
    
    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            //obj[item.field.slice(item.field.lastIndexOf('.') + 1)] = item.message;
            //obj[item.field.slice(item.field.indexOf('.') + 1).replaceAll('.', '_')] = item.message;                obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
}